import React from 'react'
import { useSelector } from 'react-redux'

import { Text } from '@fielded/shared-ui'

import { selectPayables } from '../../../../root/reducers/retailer/finances'
import { pluralize } from '../../../../van-shared/utils/utils'
import { getCategorizedPayables } from '../../../../root/reducers/retailer/finances/utils-new'

export const OverdueInfo = ({ isPaused, config }) => {
  const payables = useSelector(selectPayables)

  const { overduePayables } = getCategorizedPayables(payables)
  const overduePaymentsCount = overduePayables.length

  const warningText = (
    <Text>
      Please note that your account will be blocked and deliveries suspended <Text tag='span' bold>if any payment is overdue</Text>. Pay immediately to avoid suspension of service.
    </Text>
  )

  const blockedText = (
    <Text>
      You have <Text tag='span' bold>{overduePaymentsCount} overdue {pluralize('payment', overduePaymentsCount)}.</Text>
    </Text>
  )

  return isPaused ? blockedText : warningText
}
